import { c as _c } from "react-compiler-runtime";
import { useState, useCallback, useEffect, useRef, useMemo } from 'react';
import omit from 'transmute/omit';
import { IS_OPEN, HIDE_EMBEDDED_COMMENTS, MODULES_WITH_REPLIES, IS_COMMENT_MODE_ACTIVE, BROADCAST_COMMENT_MESSAGE } from 'collaboration-sidebar/constants/CollaborationSidebarStateProperties';
import usePrevious from 'collaboration-sidebar/hooks/usePrevious';
import useIsCommentIconVisibleFromFilter from './useIsCommentIconVisibleFromFilter';
const ESCAPE_KEY_CODE = 27;
const EMPTY_FUNCTION = () => {};
export default function useEmbeddedComments(t0) {
  "use memo";

  const $ = _c(56);
  const {
    moduleId,
    collaborationSidebarState,
    onUpdateCollaborationSidebarState,
    onRemoveComment: t1
  } = t0;
  const onRemoveComment = t1 === undefined ? EMPTY_FUNCTION : t1;
  const {
    isEmbeddedCommentingEnabled,
    appName,
    objectId,
    objectType,
    modulesWithReplies,
    replyCounts,
    isCommentModeActive,
    hideEmbeddedComments,
    commentsFilter
  } = collaborationSidebarState;
  const modulesWithRepliesRef = useRef(modulesWithReplies);
  const replyCountsRef = useRef(replyCounts);
  let t2;
  if ($[0] !== modulesWithReplies || $[1] !== replyCounts) {
    t2 = () => {
      modulesWithRepliesRef.current = modulesWithReplies;
      replyCountsRef.current = replyCounts;
    };
    $[0] = modulesWithReplies;
    $[1] = replyCounts;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  useEffect(t2);
  const [isCommenting, setIsCommenting] = useState(false);
  let t3;
  if ($[3] !== onUpdateCollaborationSidebarState) {
    t3 = () => {
      onUpdateCollaborationSidebarState({
        [IS_COMMENT_MODE_ACTIVE]: false
      });
    };
    $[3] = onUpdateCollaborationSidebarState;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const cancelCommentMode = t3;
  let t4;
  if ($[5] !== cancelCommentMode) {
    t4 = t5 => {
      const {
        keyCode
      } = t5;
      if (keyCode === ESCAPE_KEY_CODE) {
        cancelCommentMode();
      }
    };
    $[5] = cancelCommentMode;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const onEscapeKeyDown = t4;
  let t5;
  if ($[7] !== isCommentModeActive || $[8] !== isEmbeddedCommentingEnabled || $[9] !== onEscapeKeyDown || $[10] !== onUpdateCollaborationSidebarState) {
    t5 = () => {
      if (isEmbeddedCommentingEnabled && !isCommentModeActive) {
        window.addEventListener("keydown", onEscapeKeyDown);
        window.focus();
        onUpdateCollaborationSidebarState({
          [IS_OPEN]: false,
          [IS_COMMENT_MODE_ACTIVE]: true
        });
      }
    };
    $[7] = isCommentModeActive;
    $[8] = isEmbeddedCommentingEnabled;
    $[9] = onEscapeKeyDown;
    $[10] = onUpdateCollaborationSidebarState;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  const startCommentMode = t5;
  let t6;
  if ($[12] !== onUpdateCollaborationSidebarState) {
    t6 = (parentCommentId, by) => {
      var _replyCountsRef$curre, _replyCountsRef$curre2;
      if (!parentCommentId) {
        return;
      }
      const currentReplyCount = (_replyCountsRef$curre = (_replyCountsRef$curre2 = replyCountsRef.current[parentCommentId]) === null || _replyCountsRef$curre2 === void 0 ? void 0 : _replyCountsRef$curre2.replyCount) !== null && _replyCountsRef$curre !== void 0 ? _replyCountsRef$curre : 0;
      onUpdateCollaborationSidebarState({
        replyCounts: Object.assign({}, replyCountsRef.current, {
          [parentCommentId]: {
            replyCount: Math.max(currentReplyCount + by, 0)
          }
        })
      });
    };
    $[12] = onUpdateCollaborationSidebarState;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  const incrementReplyCountBy = t6;
  let t7;
  if ($[14] !== onUpdateCollaborationSidebarState) {
    t7 = (repliedModuleId, comment) => {
      onUpdateCollaborationSidebarState({
        [MODULES_WITH_REPLIES]: Object.assign({}, modulesWithRepliesRef.current, {
          [repliedModuleId]: comment
        })
      });
    };
    $[14] = onUpdateCollaborationSidebarState;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  const setModuleReply = t7;
  let t8;
  if ($[16] !== onUpdateCollaborationSidebarState) {
    t8 = broadcastMessage => {
      onUpdateCollaborationSidebarState({
        [BROADCAST_COMMENT_MESSAGE]: broadcastMessage
      });
    };
    $[16] = onUpdateCollaborationSidebarState;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  const broadcastCommentsMessage = t8;
  let t9;
  if ($[18] !== isCommentModeActive || $[19] !== onRemoveComment || $[20] !== onUpdateCollaborationSidebarState) {
    t9 = repliedModuleId_0 => {
      onUpdateCollaborationSidebarState({
        [MODULES_WITH_REPLIES]: omit([repliedModuleId_0], modulesWithRepliesRef.current)
      });
      onRemoveComment();
      if (!isCommentModeActive) {
        setIsCommenting(false);
      }
    };
    $[18] = isCommentModeActive;
    $[19] = onRemoveComment;
    $[20] = onUpdateCollaborationSidebarState;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  const removeModuleReply = t9;
  let t10;
  if ($[22] !== onUpdateCollaborationSidebarState) {
    t10 = updatedHideEmbeddedComments => onUpdateCollaborationSidebarState({
      [HIDE_EMBEDDED_COMMENTS]: updatedHideEmbeddedComments
    });
    $[22] = onUpdateCollaborationSidebarState;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  const setHideEmbeddedComments = t10;
  let t11;
  let t12;
  if ($[24] !== isCommentModeActive || $[25] !== onEscapeKeyDown) {
    t11 = () => {
      if (!isCommentModeActive) {
        setIsCommenting(false);
        window.removeEventListener("keydown", onEscapeKeyDown);
      }
    };
    t12 = [setIsCommenting, isCommentModeActive, onEscapeKeyDown];
    $[24] = isCommentModeActive;
    $[25] = onEscapeKeyDown;
    $[26] = t11;
    $[27] = t12;
  } else {
    t11 = $[26];
    t12 = $[27];
  }
  useEffect(t11, t12);
  let t13;
  if ($[28] !== moduleId || $[29] !== modulesWithReplies) {
    t13 = moduleId ? (modulesWithReplies || {})[moduleId] : undefined;
    $[28] = moduleId;
    $[29] = modulesWithReplies;
    $[30] = t13;
  } else {
    t13 = $[30];
  }
  const moduleWithReply = t13;
  const prevModuleWithReply = usePrevious(moduleWithReply);
  let t14;
  let t15;
  if ($[31] !== moduleWithReply || $[32] !== prevModuleWithReply) {
    t14 = () => {
      if (prevModuleWithReply && !moduleWithReply) {
        setIsCommenting(false);
      }
    };
    t15 = [prevModuleWithReply, moduleWithReply];
    $[31] = moduleWithReply;
    $[32] = prevModuleWithReply;
    $[33] = t14;
    $[34] = t15;
  } else {
    t14 = $[33];
    t15 = $[34];
  }
  useEffect(t14, t15);
  let t16;
  if ($[35] !== commentsFilter || $[36] !== isCommenting || $[37] !== moduleWithReply) {
    t16 = {
      isCommenting,
      commentsFilter,
      moduleWithReply
    };
    $[35] = commentsFilter;
    $[36] = isCommenting;
    $[37] = moduleWithReply;
    $[38] = t16;
  } else {
    t16 = $[38];
  }
  const isCommentIconVisibleFromFilter = useIsCommentIconVisibleFromFilter(t16);
  const showComments = isCommentIconVisibleFromFilter && (!!moduleWithReply || isCommenting) && isEmbeddedCommentingEnabled && (!hideEmbeddedComments || isCommentModeActive);
  let t17;
  if ($[39] !== appName || $[40] !== broadcastCommentsMessage || $[41] !== cancelCommentMode || $[42] !== hideEmbeddedComments || $[43] !== incrementReplyCountBy || $[44] !== isCommentModeActive || $[45] !== isCommenting || $[46] !== isEmbeddedCommentingEnabled || $[47] !== moduleWithReply || $[48] !== objectId || $[49] !== objectType || $[50] !== removeModuleReply || $[51] !== setHideEmbeddedComments || $[52] !== setModuleReply || $[53] !== showComments || $[54] !== startCommentMode) {
    t17 = {
      isEmbeddedCommentingEnabled,
      isCommentModeActive,
      startCommentMode,
      cancelCommentMode,
      appName,
      objectId,
      objectType,
      showComments,
      isCommenting,
      setModuleReply,
      removeModuleReply,
      incrementReplyCountBy,
      setIsCommenting,
      hideEmbeddedComments,
      setHideEmbeddedComments,
      broadcastCommentsMessage,
      moduleParentComment: moduleWithReply
    };
    $[39] = appName;
    $[40] = broadcastCommentsMessage;
    $[41] = cancelCommentMode;
    $[42] = hideEmbeddedComments;
    $[43] = incrementReplyCountBy;
    $[44] = isCommentModeActive;
    $[45] = isCommenting;
    $[46] = isEmbeddedCommentingEnabled;
    $[47] = moduleWithReply;
    $[48] = objectId;
    $[49] = objectType;
    $[50] = removeModuleReply;
    $[51] = setHideEmbeddedComments;
    $[52] = setModuleReply;
    $[53] = showComments;
    $[54] = startCommentMode;
    $[55] = t17;
  } else {
    t17 = $[55];
  }
  return t17;
}